var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_vm._m(0),_c('span',{staticClass:"float-right app-footername"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"float-left"},[_c('a',{attrs:{"href":"https://www.emi.edu.bo","target":"_blank"}},[_vm._v("EMI")]),_vm._v(" - Todos los derechos reservados. ")])
}]

export { render, staticRenderFns }